export { AuthModalComponentEnum, AuthModalComponentEnumValue } from "./auth-modal-component.enum";